import { defineMessages } from 'react-intl';

export const expressServiceInfoMessages = defineMessages({
  expressServiceDeliveryUntil: {
    id: 'expressService.delivery.until',
    defaultMessage: 'Lieferung am {day}',
  },
  expressServiceDeliveryCountdown: {
    id: 'expressService.delivery.countdown',
    defaultMessage: 'Bestelle innerhalb {countdown} im <modal>24h Service</modal>',
  },
  modalHeadline: {
    defaultMessage: '24-Stunden-Lieferung',
    id: 'expressService.modal-headline',
  },
});
